<template>
    <v-dialog v-model="isVisible" persistent light max-width="450">
        <template #activator="{ on, attrs }">
            <slot :attrs="attrs" :on="on">
                <v-btn v-bind="attrs" v-on="on" class="boxed-icon" color="primary" tile elevation="0">
                    {{ $t('workflow_prototype.back_to_design') }}
                    <v-icon right>mdi-cancel</v-icon>
                </v-btn>
            </slot>
        </template>
        <v-card>
            <v-card-title class="headline primary">{{ $t('workflow_prototype.heading_back_to_design') }}</v-card-title>
            <v-card-text class="tiemposText mt-4">
                {{ $t('workflow_prototype.explanation_back_to_design') }}
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn text class="mr-4 mb-2" @click="isVisible = false">{{ $t('global.cancel') }}</v-btn>
                <v-btn color="primary" class="boxed-icon pr-0 mr-4 mb-2" tiles elevation="0" @click="unapproveDesign(); isVisible = false">
                    {{ $t('workflow_prototype.back_to_design') }}
                    <v-icon right>mdi-arrow-left</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { toggleable } from '@/mixins/toggleable';
import { PROJECT_DESIGN } from '@/router/projects';

export default {
    name: 'WorkflowDesignUnapproveDialog',

    mixins: [toggleable],

    methods: {
        unapproveDesign () {
            this.$unapproveStep(PROJECT_DESIGN);
        },
    },
};
</script>

<style scoped>

</style>
